// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fc-h-event .fc-event-title-container {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  font-size: 12px;\n}", "",{"version":3,"sources":["webpack://src/pages/atividades/agenda.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".fc-h-event .fc-event-title-container {\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
